import { SVGProps, Ref, forwardRef } from 'react';

export const HhBusinessAppBrandSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <rect x={1} y={1} width={14} height={14} rx={3.64} fill="#1B1B1B" />
        <path
            d="M11.532 7.152c-.212-.224-.513-.347-.88-.347-.457 0-.808.19-1.01.548V5.58H8.583v4.86h1.06V8.73c0-.398.079-.653.198-.803a.55.55 0 0 1 .454-.208c.155 0 .277.051.364.143.086.096.135.242.135.446v2.127h1.06V8.095c0-.398-.113-.722-.322-.943"
            fill="white"
        />
        <path
            d="M7.455 7.152c-.212-.224-.513-.347-.88-.347-.458 0-.808.19-1.01.548V5.58h-1.06v4.86h1.06V8.73c0-.398.08-.653.198-.803a.55.55 0 0 1 .454-.208c.155 0 .278.051.364.143.086.096.135.242.135.446v2.127h1.06V8.095c0-.398-.113-.722-.321-.943"
            fill="white"
        />
    </svg>
));
HhBusinessAppBrandSize16Glyph.displayName = 'HhBusinessAppBrandSize16Glyph';
